<template>
  <div>
    <v-alert type="info" outlined dense class="mb-4">
      Bu araç geçmiş faturaları değiştirmez. Değişiklikler ileriye dönük yeni
      dönem akışı için hazırlanır.
    </v-alert>

    <v-row dense>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="pb-1">Operasyon Özeti</v-card-title>
          <v-card-subtitle>
            Seçtiğiniz bitiş tarihi için etkilenmesi beklenen portföy görünümü
          </v-card-subtitle>

          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="6" md="3">
                <v-sheet outlined rounded class="pa-3">
                  <div class="text-caption text--secondary">
                    Yıllık Yenileme
                  </div>
                  <div class="text-h5 font-weight-bold">
                    {{ formatInteger(snapshot.yearly_renewal_count) }}
                  </div>
                </v-sheet>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-sheet outlined rounded class="pa-3">
                  <div class="text-caption text--secondary">Aylık Geçiş</div>
                  <div class="text-h5 font-weight-bold">
                    {{ formatInteger(snapshot.monthly_transition_count) }}
                  </div>
                </v-sheet>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-sheet outlined rounded class="pa-3">
                  <div class="text-caption text--secondary">Ürün Kararı</div>
                  <div class="text-h5 font-weight-bold">
                    {{ formatInteger(snapshot.product_decision_count) }}
                  </div>
                </v-sheet>
              </v-col>

              <v-col cols="12" sm="6" md="3">
                <v-sheet outlined rounded class="pa-3">
                  <div class="text-caption text--secondary">Bloklu</div>
                  <div class="text-h5 font-weight-bold error--text">
                    {{ formatInteger(snapshot.blocked_count) }}
                  </div>
                </v-sheet>
              </v-col>
            </v-row>

            <v-alert
              v-if="snapshot.blocked_count > 0"
              type="warning"
              icon="mdi-information"
              outlined
              dense
              class="mt-4 mb-0"
            >
              Seçilen tarihte yenilenecek kayıtlar arasında, eksik kurulum veya
              kapsama engeli olanlar bloklu olarak ayrıştırılır.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="pb-1">Operasyon</v-card-title>
          <v-card-subtitle>
            Bitiş tarihini seçin. Araç bu tarihte biten kayıtları yıl sonuna
            hizalayacak geçiş için hazırlar.
          </v-card-subtitle>

          <v-card-text>
            <v-row dense class="mb-3">
              <v-col cols="12" sm="6">
                <rs-datepicker
                  label="Bitiş Tarihi (t)"
                  v-model="formData.snapshot_date"
                  :disabled="loading"
                />
              </v-col>

              <v-col cols="12" sm="6">
                <rs-datepicker
                  label="Yeni Dönem Başlangıcı"
                  :value="nextPeriodStart"
                  disabled
                  :filled-on-disabled="false"
                />
              </v-col>
            </v-row>

            <div class="text-subtitle-2 mt-1 mb-1">Kapsam</div>
            <v-row dense class="mb-4 mt-0">
              <v-col cols="12" sm="4">
                <v-checkbox
                  class="mt-0 pt-0 scope-checkbox"
                  v-model="formData.include_yearly"
                  label="Yıllık Yenilemeler"
                  hide-details
                  :disabled="loading"
                />
              </v-col>

              <v-col cols="12" sm="4">
                <v-checkbox
                  class="mt-0 pt-0 scope-checkbox"
                  v-model="formData.include_monthly"
                  label="Aylık Fiyat Geçişleri"
                  hide-details
                  :disabled="loading"
                />
              </v-col>

              <v-col cols="12" sm="4">
                <v-checkbox
                  class="mt-0 pt-0 scope-checkbox"
                  v-model="formData.include_product_decisions"
                  label="Ürün Kararı Gerekenler"
                  hide-details
                  :disabled="loading"
                />
              </v-col>
            </v-row>

            <div class="text-subtitle-2 mb-2">Yenileme Kuralı</div>
            <v-radio-group
              v-model="formData.default_rule_type"
              row
              class="mt-0 transition-rule-group"
              :disabled="loading"
            >
              <v-radio label="Aynı Ürünle Devam Et" value="same_product" />
              <v-radio
                label="Fiyat Güncelleyerek Devam Et"
                value="update_price"
              />
              <v-radio
                label="Kayıt Bazında Karar Vereceğim"
                value="manual_decision"
              />
            </v-radio-group>

            <v-row
              v-if="formData.default_rule_type === 'update_price'"
              dense
              class="mt-1"
            >
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model.number="formData.price_increase_percent"
                  label="Artış Oranı"
                  outlined
                  dense
                  type="number"
                  step="0.01"
                  min="0"
                  suffix="%"
                  :disabled="loading"
                />
              </v-col>
            </v-row>

            <v-alert
              v-if="formData.default_rule_type === 'update_price'"
              type="info"
              outlined
              dense
              class="mt-2 mb-0"
            >
              Girilen oran aylık ve yıllık hazır satırlara varsayılan olarak
              uygulanır. Satır bazlı override girilirse bu kural ezilir.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "PortfolioYearEndTransitionSetupStep",
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    formData: {
      type: Object,
      required: true,
    },
    snapshot: {
      type: Object,
      required: true,
    },
    nextPeriodStart: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    formatInteger(value) {
      return new Intl.NumberFormat("tr-TR", {
        maximumFractionDigits: 0,
      }).format(Number(value || 0));
    },
  },
};
</script>

<style scoped>
.scope-checkbox :deep(.v-label) {
  margin-bottom: 0;
}

.transition-rule-group :deep(.v-label) {
  margin-bottom: 0;
}
</style>
